import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="layout">
      <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <Sidebar isOpen={isSidebarOpen} />

      <div
        className={`main-content ${isSidebarOpen ? "expanded" : "collapsed"}`}
      >
        <div className="content-area">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
